<div class="requestCard d-flex">
  <div class="requestNameDetails text-truncate">
    <h4 class="font-weight-400 text-truncate">{{ companyName }} <span *ngIf="toRenew"> - Renewal</span></h4>
    <p class="margin-0 text-truncate">
      {{ companyContact }}
    </p>
  </div>

  <div>
    <p class="mt-0 text-end">
      {{ template }}
    </p>
    <div class="requestButtons d-flex flex-nowrap justify-content-end">
      <button
        class="btn btn-darkerGrey badge badge-darkerGrey font-weight-500"
        (click)="getInfoDecline(companyName, companyContact)"
        title="Decline request"
      >
        DECLINE
      </button>
      <button
        class="btn btn-success badge badge-success font-weight-500"
        (click)="getInfoAccept(companyName, companyContact)"
        title="Accept request"
      >
        ACCEPT
      </button>
    </div>
  </div>
</div>
